import { render, staticRenderFns } from "./SmsTextBoxFooter.vue?vue&type=template&id=a8a39e86&scoped=true"
import script from "./SmsTextBoxFooter.vue?vue&type=script&lang=js"
export * from "./SmsTextBoxFooter.vue?vue&type=script&lang=js"
import style0 from "./SmsTextBoxFooter.vue?vue&type=style&index=0&id=a8a39e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a39e86",
  null
  
)

export default component.exports